import { render, staticRenderFns } from "./view-detail.vue?vue&type=template&id=19c4f726&scoped=true"
import script from "./view-detail.vue?vue&type=script&lang=js"
export * from "./view-detail.vue?vue&type=script&lang=js"
import style0 from "./view-detail.vue?vue&type=style&index=0&id=19c4f726&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4f726",
  null
  
)

export default component.exports